import CONSTANTS from "../CONSTANTS";

export const actionSetUserAuthorization = (authorization) => ({
  type: CONSTANTS.USERS_AUTHORIZATION_SET,
  authorization,
});
export const actionResetUserAuthorization = () => ({
  type: CONSTANTS.USERS_AUTHORIZATION_RESET,
});
